import { Link, NavLink, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";

const LOGO_URL = "https://customer-assets-wrfwihn1.emergentagent.net/job_rencana-tumbuh/artifacts/fd4d8d611f35bfb2_LOGO%20PROPER%20ENERGY%20-%20WBC.png";

const NAV = [
  { to: "/plts-tumbuh", label: "PLTS Tumbuh" },
  { to: "/simulasi", label: "Simulasi" },
  { to: "/konfigurator", label: "Konfigurator" },
  { to: "/proyek", label: "Proyek" },
  { to: "/insight", label: "Insight" },
  { to: "/tentang", label: "Tentang" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const loc = useLocation();
  useEffect(() => { setOpen(false); }, [loc.pathname]);

  return (
    <header
      className="sticky top-0 z-40 border-b bg-white/90 backdrop-blur-md"
      style={{ borderColor: "var(--pe-border)" }}
      data-testid="site-header"
    >
      <div className="pe-container flex items-center justify-between h-20">
        <Link to="/" className="flex items-center gap-3" data-testid="nav-logo">
          <img src={LOGO_URL} alt="Proper Energy" className="h-9 w-auto" />
        </Link>

        <nav className="hidden lg:flex items-center gap-7" data-testid="nav-primary">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              data-testid={`nav-link-${n.to.replace("/", "")}`}
              className={({ isActive }) =>
                `text-sm font-medium transition-colors ${
                  isActive ? "text-[color:var(--pe-primary)]" : "text-[color:var(--pe-text)] hover:text-[color:var(--pe-primary)]"
                }`
              }
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <Link to="/kontak" className="pe-btn-primary text-sm" data-testid="nav-cta-konsultasi">
            Konsultasi
          </Link>
        </div>

        <button
          className="lg:hidden p-2 -mr-2"
          onClick={() => setOpen(!open)}
          aria-label="Menu"
          data-testid="nav-mobile-toggle"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t bg-white" style={{ borderColor: "var(--pe-border)" }} data-testid="nav-mobile-panel">
          <div className="pe-container py-4 flex flex-col gap-1">
            {NAV.map((n) => (
              <Link
                key={n.to}
                to={n.to}
                className="py-3 text-base font-medium"
                data-testid={`nav-mobile-link-${n.to.replace("/", "")}`}
              >
                {n.label}
              </Link>
            ))}
            <Link to="/kontak" className="pe-btn-primary mt-3 justify-center" data-testid="nav-mobile-cta">
              Konsultasi
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
